import Swal from 'sweetalert2';
import DropboxInteraction from 'data/DropboxInteractions';
import Events from 'redux/events';
import blackList from 'consts/BlackList';

export const addBundle = (bundle) => {
    return (dispatch, getState) => {
        let state = getState();
        if(state.bundles.findIndex(b => b.id === bundle.id) === -1)
        {
            let bundles = [...state.bundles, bundle]
            let soundbox = {
                "id": bundle.id,
                "movies" : [],
                "characters": [],
                "sounds": []
            };
            DropboxInteraction.createFolders([
                `/bundle_${bundle.id}/banner`,
                `/bundle_${bundle.id}/characters`,
                `/bundle_${bundle.id}/images`,
                `/bundle_${bundle.id}/sounds`,
            ]);
            DropboxInteraction.saveBundleFile(JSON.stringify({ bundles: bundles }));
            DropboxInteraction.saveDataFile(bundle.id, JSON.stringify(soundbox));
            dispatch({
                type: Events.ADD_BUNDLE,
                bundles: bundles,
                soundboxs: [...state.soundboxs, soundbox]
            });
        }
    }
};
export const sortBundle = (oldIndex, newIndex) => {
    return (dispatch, getState) => {
        let bundles = getState().bundles;
        let temp = bundles[oldIndex];
        bundles.splice(oldIndex, 1);
        bundles.splice(newIndex, 0, temp);
        DropboxInteraction.saveBundleFile(JSON.stringify({ bundles: bundles }));
        dispatch({
            type: Events.SORT_BUNDLE,
            bundles: bundles
        });
    }
};
export const editBundle = (id, bundle) => {
    return async (dispatch, getState) => {
        let state = getState();
        let oldIndex = state.bundles.findIndex(b => b.id === id);
        let newIndex = state.bundles.findIndex(b => b.id === bundle.id);
        let bundles = [...state.bundles];
        bundles.splice(oldIndex, 1, bundle);
        if(bundle.id !== id && newIndex !== -1) {
            Swal.fire({
                title: `Id de bundle déjà occupé !`,
                text: `Un bundle possède déjà l'id ${bundle.id}.`,
                icon: 'error',
                confirmButtonText: 'Ok'
            });
        } else if(bundle.id === id ) {
            DropboxInteraction.saveBundleFile(JSON.stringify({ bundles: bundles }));
            dispatch({ 
                type: Events.EDIT_BUNDLE,
                bundles: bundles,
                soundboxs: state.soundboxs,
            });
        } else {
            dispatch({ type: Events.LOADING });
            // FIND ALL FILES
            let response = await DropboxInteraction.searchFiles(
                `/bundle_${id}`,
                `_${id}`,
            );
            // FORM [OLD PATH / NEW PATH] PAIRS
            let entries = [], 
                folderData = [
                    ['img', '/images', false],
                    ['sound', '/sounds', false],
                    ['character', '/characters', false],
                    ['banner', '/banner', false],
                    ['data', '', false]
                ];
            for(let i=0; i<response.matches.length; i++) {
                let matchPath = response.matches[i].metadata;
                let index = folderData.findIndex(array => matchPath.name.includes(array[0]));
                if(folderData[index] !== undefined) {
                    folderData[index][2] = true;
                    entries.push({
                        from_path: matchPath.path_lower,
                        to_path: `/bundle_${bundle.id}${folderData[index][1]}/`+matchPath.name.replace(`${folderData[index][0]}_${id}`,`${folderData[index][0]}_${bundle.id}`),
                    });
                }
            }
            for(let i=0; i<folderData.length; i++) {
                if(folderData[i][2] === false) {
                    entries.push({
                        from_path: `/bundle_${id}${folderData[i][1]}`,
                        to_path: `/bundle_${bundle.id}${folderData[i][1]}`,
                    });
                }
            }
            // LAUNCH FILE MOVING AND WAIT END OF PROCESSING
            response = await DropboxInteraction.moveFiles(entries);
            const { async_job_id } = response;
            if (async_job_id) {
                do {
                    response = await DropboxInteraction.moveFilesCheck(async_job_id);
                } while (response['.tag'] === 'in_progress');
            }
    
            // DELETE PREVIOUS FOLDER WHEN FINISHED
            DropboxInteraction.deleteFile(`/bundle_${id}`);
    
            // CHANGE SOUNDBOX JSON CONTENT ID, BUNDLE CONTENT ID, AND REMOVE LOADING SCREEN
            let soundboxIndex = state.soundboxs.findIndex(soundbox => soundbox.id === id),
                soundboxs = [...state.soundboxs];
            soundboxs[soundboxIndex].id = bundle.id
    
            DropboxInteraction.saveBundleFile(JSON.stringify({ bundles: bundles }));
            DropboxInteraction.saveDataFile(bundle.id, JSON.stringify(soundboxs[soundboxIndex]));
            dispatch({
                type: Events.EDIT_BUNDLE,
                bundles: bundles,
                soundboxs: soundboxs
            });
        }
    };
};
export const deleteBundle = (id) => {
    return (dispatch, getState) => {
        let state = getState();
        let bundles = [...state.bundles]
        let soundboxs = [...state.soundboxs]
        bundles.splice(bundles.findIndex(bundle => bundle.id === id), 1);
        soundboxs.splice(soundboxs.findIndex(soundbox => soundbox.id === id), 1);
        DropboxInteraction.deleteFile(`/bundle_${id}`);
        DropboxInteraction.saveBundleFile(JSON.stringify({ bundles: bundles }));
        dispatch({
            type: Events.ADD_BUNDLE,
            bundles: bundles,
            soundboxs: soundboxs
        });
    }
};
export const addCharacter = (soundbox, character) => {
    return (dispatch, getState) => {
        let state = getState();
        if(soundbox.characters.findIndex(c => c.id === character.id) === -1)
        {
            let soundboxs = state.soundboxs;
            soundbox.characters = [...soundbox.characters, character];
            soundbox.movies.sort((a,b) => a.id-b.id);
            soundboxs.splice(soundboxs.findIndex(s => s.id === soundbox.id), 1, soundbox);
            DropboxInteraction.saveDataFile(soundbox.id, JSON.stringify(soundbox));
            dispatch({
                type: Events.ADD_CHARACTER,
                soundboxs: soundboxs,
            });
        }
    }
};
export const editCharacter = (soundbox, oldId, character) => {
    return (dispatch, getState) => {
        let oldIndex = soundbox.characters.findIndex(c => c.id === oldId);
        let newIndex = soundbox.characters.findIndex(c => c.id === character.id);
        if(oldIndex === newIndex || newIndex === -1)
        {
            let state = getState(),
                soundboxs = state.soundboxs;
            soundbox.characters.splice(oldIndex, 1, character);
            soundbox.characters.sort((a,b) => a.id-b.id);
            if(oldIndex !== newIndex) {
                soundbox.sounds = soundbox.sounds.map( sound => {
                    let index = sound.characters.indexOf(oldId);
                    if(~index) sound.characters[index] = character.id;
                    return sound;
                });
            }
            soundboxs.splice(soundboxs.findIndex(s => s.id === soundbox.id), 1, soundbox);
            DropboxInteraction.saveDataFile(soundbox.id, JSON.stringify(soundbox));
            dispatch({
                type: Events.EDIT_CHARACTER,
                soundboxs: soundboxs,
            });
        }
    }
};
export const deleteCharacter = (soundbox, id) => {
    return (dispatch, getState) => {
        let index = soundbox.characters.findIndex(c => c.id === id);
        if(index !== -1)
        {
            let state = getState(),
                soundboxs = state.soundboxs;
            soundbox.characters.splice(index, 1);
            soundbox.sounds = soundbox.sounds.map(sound => 
                {
                    let index = sound.characters.indexOf(id);
                    if(~index) sound.characters.splice(index, 1);
                    return sound;
                }
            );
            soundboxs.splice(soundboxs.findIndex(s => s.id === soundbox.id), 1, soundbox);
            DropboxInteraction.saveDataFile(soundbox.id, JSON.stringify(soundbox));
            dispatch({
                type: Events.DELETE_CHARACTER,
                soundboxs: soundboxs,
            });
        }
    }
};
export const addMovie = (soundbox, movie) => {
    return (dispatch, getState) => {
        let state = getState();
        if(soundbox.movies.findIndex(c => c.id === movie.id) === -1)
        {
            let soundboxs = state.soundboxs;
            soundbox.movies = [...soundbox.movies, movie];
            soundbox.movies.sort((a,b) => a.id-b.id);
            soundboxs.splice(soundboxs.findIndex(s => s.id === soundbox.id), 1, soundbox);
            DropboxInteraction.saveDataFile(soundbox.id, JSON.stringify(soundbox));
            dispatch({
                type: Events.ADD_MOVIE,
                soundboxs: soundboxs,
            });
        }
    }
};
export const editMovie = (soundbox, oldId, movie) => {
    return (dispatch, getState) => {
        let oldIndex = soundbox.movies.findIndex(c => c.id === oldId);
        let newIndex = soundbox.movies.findIndex(c => c.id === movie.id);
        if(oldIndex === newIndex || newIndex === -1)
        {
            let state = getState(),
                soundboxs = state.soundboxs;
            soundbox.movies.splice(oldIndex, 1, movie);
            soundbox.movies.sort((a,b) => a.id-b.id);
            soundboxs.splice(soundboxs.findIndex(s => s.id === soundbox.id), 1, soundbox);
            DropboxInteraction.saveDataFile(soundbox.id, JSON.stringify(soundbox));
            dispatch({
                type: Events.EDIT_MOVIE,
                soundboxs: soundboxs,
            });
        }
    }
};
export const deleteMovie = (soundbox, id) => {
    return (dispatch, getState) => {
        let index = soundbox.movies.findIndex(c => c.id === id);
        if(index !== -1)
        {
            let state = getState(),
                soundboxs = state.soundboxs;
            soundbox.movies.splice(index, 1);
            soundboxs.splice(soundboxs.findIndex(s => s.id === soundbox.id), 1, soundbox);
            DropboxInteraction.saveDataFile(soundbox.id, JSON.stringify(soundbox));
            dispatch({
                type: Events.DELETE_MOVIE,
                soundboxs: soundboxs,
            });
        }
    }
};
export const addSound = (soundboxId, sound) => {
    return (dispatch, getState) => {
        let soundboxs = getState().soundboxs,
            soundbox = soundboxs.find(s => s.id === soundboxId);
        if(soundbox !== undefined && soundbox.sounds.findIndex(s => s.id === sound.id))
        {
            soundbox.sounds.push(sound);
            soundboxs.splice(soundboxs.findIndex(s => s.id === soundbox.id), 1, soundbox);
            DropboxInteraction.saveDataFile(soundbox.id, JSON.stringify(soundbox));
        }
        dispatch({
            type: Events.ADD_SOUND,
            soundboxs: soundboxs,
        });
    }
};
export const editSound = (soundboxId, oldSoundId, sound) => {
    return (dispatch, getState) => {
        let soundboxs = getState().soundboxs,
            soundbox = soundboxs.find(s => s.id === soundboxId);
        if(soundbox !== undefined)
        {
            let oldSoundIndex = soundbox.sounds.findIndex(s => s.id === oldSoundId);
            let newSoundIndex = soundbox.sounds.findIndex(s => s.id === sound.id);
            if(oldSoundId === sound.id || (oldSoundIndex !== -1 && newSoundIndex === -1)) {
                soundbox.sounds.splice(oldSoundIndex, 1, sound);
                soundboxs.splice(soundboxs.findIndex(s => s.id === soundbox.id), 1, soundbox);
                DropboxInteraction.saveDataFile(soundbox.id, JSON.stringify(soundbox));
            }
        }
        dispatch({
            type: Events.EDIT_SOUND,
            soundboxs: soundboxs,
        });
    }
};
export const sortSound = (id, oldIndex, newIndex) => {
    return (dispatch, getState) => {
        let soundboxs = getState().soundboxs,
            soundbox = soundboxs.find(s => s.id === id);
        if(soundbox !== undefined)
        {
            soundbox.sounds.splice(newIndex, 0, soundbox.sounds.splice(oldIndex, 1)[0]);
        }
        soundboxs.splice(soundboxs.findIndex(s => s.id === soundbox.id), 1, soundbox);
        DropboxInteraction.saveDataFile(soundbox.id, JSON.stringify(soundbox));
        dispatch({
            type: Events.SORT_SOUND,
            soundboxs: soundboxs
        });
    }
};
export const deleteSound = (soundboxId, id) => {
    return (dispatch, getState) => {
        let soundboxs = getState().soundboxs,
            soundbox = soundboxs.find(s => s.id === soundboxId);
        if(soundbox !== undefined)
        {
            let soundIndex = soundbox.sounds.findIndex(s => s.id === id);
            if(soundIndex !== -1) {
                soundbox.sounds.splice(soundIndex, 1);
                soundboxs.splice(soundboxs.findIndex(s => s.id === soundbox.id), 1, soundbox);
                DropboxInteraction.saveDataFile(soundbox.id, JSON.stringify(soundbox));
            }
        }
        dispatch({
            type: Events.DELETE_SOUND,
            soundboxs: soundboxs,
        });
    }
};
export const loading = () => {
    return {
      type: Events.LOADING
    };
};
export const loaded = () => {
    return {
      type: Events.LOADED
    };
};
export const loadInitialData = () => dispatch => {
    dispatch({ type: Events.LOAD_INITIAL_DATA_LOADING });
    let fr = new FileReader();

    // Load the main bundles.json file
    DropboxInteraction.getJSONFile(`/${process.env.REACT_APP_DROPBOX_BUNDLE_FILE_NAME}`)
    .then(function(response) {
        fr.readAsText(response.fileBlob);
    })
    .catch(function(error) {
        dispatch({ type: Events.LOAD_INITIAL_DATA_ERROR, error: 'MISSING_INITIAL_FILE' });
        Swal.fire({
            title: 'Fichier manquant !',
            text: 'Pas de fichier "bundles.json" trouvé.',
            icon: 'error',
            confirmButtonText: 'Ok'
        });
    });

    fr.onload = function() {
        let jsonBundles = JSON.parse(this.result);
        let jsons = [];
        // Load each matching json file (if does not exists, create it)
        for(let i=0; i<jsonBundles.bundles.length; i++) {
            let filePath = `/bundle_${jsonBundles.bundles[i].id}/data_${jsonBundles.bundles[i].id}.json`;
            DropboxInteraction.getJSONFile(filePath)
            .then(function (response) {
                let fr2 = new FileReader();
                fr2.onload = function () {
                    jsons.push(JSON.parse(this.result));
                    if(jsons.length >= jsonBundles.bundles.length) {
                        dispatch({
                            type: Events.LOAD_INITIAL_DATA_SUCCESS, 
                            data: {
                                bundles: jsonBundles.bundles,
                                soundboxs: jsons.sort((a,b) => a.id - b.id),
                                loading: false
                            }
                        });
                    }
                }
                fr2.readAsText(response.fileBlob);
            })
            .catch(function(error) {
                Swal.fire({
                    title: 'Fichier JSON manquant !',
                    text: `Pas de fichier "${filePath}" trouvé.`,
                    icon: 'error',
                    confirmButtonText: 'Ok'
                });
            });
        }
    };
};
export const loadSoundboxDistantData = (soundbox) => dispatch => {

    let soundsUrls = [],
        imagesUrls = [],
        charactersUrls = [],
        bannerUrl = undefined,
        promises = [];

    // Images
    for(let i=0; i<soundbox.sounds.length; i++) {
        promises.push(DropboxInteraction.getTemporaryLink(`/bundle_${soundbox.id}/images/img_${soundbox.id}_${soundbox.sounds[i].id}_${soundbox.sounds[i].movie}.jpg`)
        .then(function(response) {
            imagesUrls.push({id: soundbox.sounds[i].id, url: response.link});
        }).catch(function(error) {
            console.log(error);
        }));
    }
    // Sounds
    for(let i=0; i<soundbox.sounds.length; i++) {
        promises.push(DropboxInteraction.getTemporaryLink(`/bundle_${soundbox.id}/sounds/sound_${soundbox.id}_${soundbox.sounds[i].id}_${soundbox.sounds[i].movie}.mp3`)
        .then(function(response) {
            soundsUrls.push({id: soundbox.sounds[i].id, url: response.link});
        }).catch(function(error) {
            console.log(error);
        }));
    }
    // Characters
    for(let i=0; i<soundbox.characters.length; i++) {
        promises.push(DropboxInteraction.getTemporaryLink(`/bundle_${soundbox.id}/characters/character_${soundbox.id}_${soundbox.characters[i].id}.jpg`)
        .then(function(response) {
            charactersUrls.push({id: soundbox.characters[i].id, url: response.link});
        }).catch(function(error) {
            console.log(error);
        }));
    }
    // Banner
    promises.push(DropboxInteraction.getTemporaryLink(`/bundle_${soundbox.id}/banner/banner_${soundbox.id}.jpg`)
    .then(function(response) {
        bannerUrl = response.link
    }).catch(function(error) {
        console.log(error);
    }));

    Promise.all(promises).then(function(value) {
        dispatch({
            type: Events.LOAD_DISTANT_DATA_SUCCESS,
            data: {
                id: soundbox.id,
                imagesUrls: imagesUrls,
                soundsUrls: soundsUrls,
                charactersUrls: charactersUrls,
                bannerUrl: bannerUrl,
            }
         });
    });
};
export const syncDropboxSounds = (id) => {
    return async (dispatch, getState) => {

        dispatch({ type: Events.LOAD_INITIAL_DATA_LOADING });

        let state = getState(),
            soundboxs = state.soundboxs,
            soundbox = soundboxs.find(s => s.id === id),
            audioFiles = await DropboxInteraction.searchFiles(`/bundle_${id}/sync`, `.mp3`),
            imgFiles = await DropboxInteraction.searchFiles(`/bundle_${id}/sync`, `.jpg`),
            syncFiles = [];

        for(let i=0, audioMetadata; i<audioFiles.matches.length; i++) {
            audioMetadata = audioFiles.matches[i].metadata;
            for(let i=0, imgMetadata; i<imgFiles.matches.length; i++) {
                imgMetadata = imgFiles.matches[i].metadata;
                if(audioMetadata.name.slice(0,-4).localeCompare(imgMetadata.name.slice(0,-4)) === 0) {
                    syncFiles.push(imgMetadata.name.slice(0,-4));
                }
            }
        }

        syncFiles = syncFiles.sort((a,b) => a-b);
        if(syncFiles.length === 0) return;

        let files_to_move = [];
        for(let i=0, intName, soundJson, nextValidId = 1; i<syncFiles.length; i++) {
            for(let i=0; i<soundbox.sounds.length; i++) {
                if(nextValidId < soundbox.sounds[i].id) nextValidId = soundbox.sounds[i].id+1
            }
            intName = Number(syncFiles[i]);
            soundJson = {
                id: nextValidId,
                characters: [],
                movie: 1,
                title: '',
                timing: '',
                quote: ''
            }
            
            if(!isNaN(intName)) {
                if(soundbox.sounds.findIndex(s => s.id === intName) === -1) {
                    console.log("New sound at specified ID");
                    // New sound at specified ID
                    soundJson.id = intName;
                    soundbox.sounds.push(soundJson);
                    files_to_move.push({from_path: `/bundle_${id}/sync/${syncFiles[i]}.mp3`, to_path: `/bundle_${id}/sounds/sound_${id}_${soundJson.id}_1.mp3`});
                    files_to_move.push({from_path: `/bundle_${id}/sync/${syncFiles[i]}.jpg`, to_path: `/bundle_${id}/images/img_${id}_${soundJson.id}_1.jpg`});
                } else {
                    console.log('ID TAKEN FOR '+syncFiles[i]);
                }
            } else {
                console.log("New sound at next valid ID");
                // New sound at next valid ID
                soundbox.sounds.push(soundJson);
                files_to_move.push({from_path: `/bundle_${id}/sync/${syncFiles[i]}.mp3`, to_path: `/bundle_${id}/sounds/sound_${id}_${soundJson.id}_1.mp3`});
                files_to_move.push({from_path: `/bundle_${id}/sync/${syncFiles[i]}.jpg`, to_path: `/bundle_${id}/images/img_${id}_${soundJson.id}_1.jpg`});
            }
        }

        // LAUNCH FILE MOVING AND WAIT END OF PROCESSING
        let response = await DropboxInteraction.moveFiles(files_to_move);
        const { async_job_id } = response;
        if (async_job_id) {
            do {
                response = await DropboxInteraction.moveFilesCheck(async_job_id);
            } while (response['.tag'] === 'in_progress');
        }
        soundboxs.splice(soundboxs.findIndex(s => s.id === soundbox.id), 1, soundbox);
        DropboxInteraction.saveDataFile(soundbox.id, JSON.stringify(soundbox));
        dispatch({
            type: Events.SYNC_BUNDLE,
            soundboxs: soundboxs,
        });
    }
};
export const updateBlackList = (id) => {
    return (dispatch, getState) => {
        let soundboxs = getState().soundboxs,
            soundbox = soundboxs.find(s => s.id === id);
        if(soundbox !== undefined)
        {
            for(let i=0; i<soundbox.sounds.length; i++) {
                let title = soundbox.sounds[i].title;
                let quote = soundbox.sounds[i].quote;
                for(let j=0; j<blackList.length; j++) {
                    let middle = Math.floor(blackList[j].length/2);
                    let newWord = blackList[j].slice(0, middle) + "*".repeat(blackList[j].length-middle);
                    let regex = new RegExp("\\b"+blackList[j]+"\\b",'ig');
                    if(quote.match(regex)) {
                        quote = quote.replace(regex, newWord);
                    }
                    if(title.match(regex)) {
                        title = title.replace(regex, newWord);
                    }
                }
                soundbox.sounds[i].titleFiltered = title;
                soundbox.sounds[i].quoteFiltered = quote;
            }
        }
        soundboxs.splice(soundboxs.findIndex(s => s.id === soundbox.id), 1, soundbox);
        DropboxInteraction.saveDataFile(soundbox.id, JSON.stringify(soundbox));
        dispatch({
            type: Events.UPDATE_BLACK_LIST,
            soundboxs: soundboxs
        });
    }
}